import { render } from "./FormMessage.vue?vue&type=template&id=e3cad8aa&scoped=true&lang=html"
import script from "./FormMessage.vue?vue&type=script&lang=js"
export * from "./FormMessage.vue?vue&type=script&lang=js"

import "./FormMessage.vue?vue&type=style&index=0&id=e3cad8aa&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3cad8aa"]])

export default __exports__